import clsx from "clsx";

import styles from "./Spinner.module.css";
import React, { CSSProperties } from "react";

type SpinnerProps = {
  className?: string;
  style?: CSSProperties;
};

const Spinner: React.FC<SpinnerProps> = ({ className, style }) => {
  return <div className={clsx(styles.wrapper, className)} style={style} />;
};

export default Spinner;
